import React, { useCallback, useEffect, useState } from "react";
import { Form, Popconfirm } from "antd";
import ObjectFormItem from "./atomics/object-form-item";
import withLoadData from "./with-load-data";
import { compose } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { OBJECT_TYPES } from "../../constants/project";
import classes from "./object-details-modal.module.scss";
import { mergeLeft, pathOr, propOr } from "ramda";
import classNames from "classnames";

const ObjectDetailsModal = ({
  attributes,
  initData,
  type,
  object,
  isEditing,
  onSubmit = () => {},
  onDelete = () => {},
  form,
  autoFocusFieldRef,
}) => {
  const [data, setData] = useState(attributes);
  const [defaultTemplateData, setDefaultTemplateData] = useState([]);

  const handleOnSubmitForm = (values) => {
    const sendData = mergeLeft(values, initData);

    if (isEditing) {
      if (typeof sendData.text === "boolean") {
        sendData.text = sendData.text ? "True" : "False";
      }

      if (Array.isArray(sendData.text)) {
        sendData.text = sendData.text.join("|");
      }

      return onSubmit(sendData, isEditing);
    }

    if (type === OBJECT_TYPES.DETECTED_FIELD) {
      if (typeof sendData.text === "boolean") {
        sendData.text = sendData.text ? "True" : "False";
      }

      if (Array.isArray(sendData.text)) {
        sendData.text = sendData.text.join("|");
      }

      return onSubmit(
        {
          ...sendData,
          objectType: type,
          objectId: object.data.id,
          type: object.data.type,
          items: propOr(null, "items", object.data),
          fieldData: {
            top: object.data.top,
            left: object.data.left,
            width: object.data.width,
            height: object.data.height,
          },
        },
        isEditing
      );
    }
    return onSubmit(
      { ...sendData, objectType: type, objectId: uuidv4() },
      isEditing
    );
  };

  useEffect(() => {
    setData(attributes);
  }, [attributes]);

  useEffect(() => {
    setTimeout(() => {
      form.setFieldsValue(initData);
    }, 0);
  }, [initData]);

  const getObjectFormItemKey = useCallback(
    (item, index) => {
      const id = pathOr(
        pathOr("NewItem", ["data", "id"], object),
        ["data", "objectId"],
        object
      );
      return id + item.name + index;
    },
    [object]
  );

  useEffect(() => {
    if (type === OBJECT_TYPES.DETECTED_FIELD) {
      setDefaultTemplateData([
        {
          label: `Pragma to make this field readonly: ##flattenThisControl##`,
          value: "##flattenThisControl##",
          type: "system",
        },
      ]);
    } else if (type === OBJECT_TYPES.ANNOTATION) {
      setDefaultTemplateData([
        {
          label: `Page number: {{$$PageNumber}} of {{$$PageCount}}`,
          value: "{{$$PageNumber}} of {{$$PageCount}}",
          type: "system",
        },
        {
          label: `New line: {{$$newLine}}`,
          value: "{{$$newLine}}",
          type: "system",
        },
      ]);
    }
  }, [type]);

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={initData}
      onFinish={handleOnSubmitForm}
      onFinishFailed={() => {}}
    >
      {data.map((item, index) => (
        <div key={index}>
          <ObjectFormItem
            key={getObjectFormItemKey(item, index)}
            item={item}
            data={object.data}
            objectType={type}
            form={form}
            autoFocusFieldRef={autoFocusFieldRef}
            defaultTemplateData={defaultTemplateData}
          />
        </div>
      ))}

      <div className={classes.ActionWrap}>
        <div>
          {isEditing && (
            <Popconfirm
              placement="top"
              title="Are you sure you want to delete this object?"
              onConfirm={() => onDelete(initData.objectId)}
              okText="Yes"
              cancelText="No"
            >
              <button className={classNames(classes.Button, "btn btn-danger")}>
                Delete
              </button>
            </Popconfirm>
          )}
        </div>
      </div>
    </Form>
  );
};

export default compose(withLoadData)(ObjectDetailsModal);
